import type { SubscriptionTier } from './types';
import { TIERS_LOW_TO_HIGH } from './tiersLowToHigh';

export const compareTiers = (a: SubscriptionTier, b: SubscriptionTier): number => {
  return TIERS_LOW_TO_HIGH.indexOf(a) - TIERS_LOW_TO_HIGH.indexOf(b);
};
